import { type AxiosRequestConfig } from 'axios'

const addUserJob = (data: any): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/user/info/job/item',
    data
  }
}

export { addUserJob }
